const options = {
  5: "bg-stone-700/5",
  10: "bg-stone-700/10",
  25: "bg-stone-700/25",
  50: "bg-stone-700/50",
  75: "bg-stone-700/75",
  90: "bg-stone-700/90",
  100: "bg-stone-700",
};

const from = {
  5: "from-stone-700/5",
  10: "from-stone-700/10",
  25: "from-stone-700/25",
  50: "from-stone-700/50",
  75: "from-stone-700/75",
  90: "from-stone-700/90",
  100: "from-stone-700",
};

export default function getBackgroundStone700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
